import { render } from "./Partners.vue?vue&type=template&id=657c0a9c&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=657c0a9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657c0a9c"]])

export default __exports__